/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, string, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Link from '@material-ui/core/Link';
import Media from 'react-media';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = () => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '30px 0',
        width: '100%',
        height: 'auto',
    },
    rootMobile: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '10px 0 10px',
        width: '100%',
        height: 'auto',
    },
    banner: {
        width: '100%',
        margin: '0 auto',
        maxWidth: '100%',
    },
});

const ZoneTenUI = ({
    classes, data, ssrDeviceType = '', trackEvent, presentationFamily,
}) => {
    const {
        link: { href = '', title = '' } = {},
        tracking_event_category = '',
        tracking_event_action = '',
        tracking_event_label = '',
    } = data;
    const desktopImageUrl = data?.desktop_image?.url;
    const mobileImageUrl = data?.mobile_image?.url;
    const imageTitleDesktop = data?.desktop_image?.title;
    const imageTitleMobile = data?.mobile_image?.title;
    const isFoodBrand = presentationFamily === 'food';
    // TODO: Refactor for cleaner code.
    return (
        <>
            <Media
                query="(min-width: 767px)"
                defaultMatches={ssrDeviceType === 'desktop'}
                render={() => (
                    <Link
                        href={href}
                        className={classes.root}
                        title={title}
                        onClick={() => {
                            trackEvent({
                                eventCategory: tracking_event_category || '',
                                eventAction: tracking_event_action || '',
                                eventLabel: tracking_event_label || '',
                                eventName: 'feature_interaction', // Requird for GA4 feature_click
                            });
                        }}
                    >
                        <img className={isFoodBrand && classes.banner} src={desktopImageUrl} alt={imageTitleDesktop} />
                    </Link>
                )}
            />

            <Media
                query="(max-width: 767px)"
                defaultMatches={ssrDeviceType === 'mobile'}
                render={() => (
                    <Link
                        href={href}
                        className={classes.rootMobile}
                        title={title}
                        onClick={() => {
                            trackEvent({
                                eventCategory: tracking_event_category || '',
                                eventAction: tracking_event_action || '',
                                eventLabel: tracking_event_label || '',
                                eventName: 'feature_interaction', // Requird for GA4 feature_click
                            });
                        }}
                    >
                        <img className={classes.banner} src={mobileImageUrl} alt={imageTitleMobile} />
                    </Link>
                )}
            />
        </>
    );
};

ZoneTenUI.propTypes = {
    trackEvent: func.isRequired,
    classes: object.isRequired,
    data: shape({
        desktop_image: shape({
            url: string,
            title: string,
        }),
        link: shape({
            href: string,
        }),
    }).isRequired,
    ssrDeviceType: string.isRequired,
    presentationFamily: string.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(ZoneTenUI));
